/**
 * Ember Zendesk Localization Adapter
 *
 * This adapter bridges the Ember Zendesk Localization service to the framework-agnostic
 * ZendeskLocalization interface from @repo/poly-hooks, allowing React components in
 * Ember apps to use Zendesk localization without depending on Ember services directly.
 */

import type { ZendeskLocalization } from '@repo/poly-hooks/zendesk-localization';

export function createEmberZendeskLocalizationAdapter(
  zendeskLocalizationService: any
): ZendeskLocalization {
  const organizationCountry = zendeskLocalizationService.organizationCountry as string;
  const userLocale = zendeskLocalizationService.userLocale as string;

  // Build base URL for Zendesk help center
  const baseUrl = `https://support-${organizationCountry}.qonto.com/hc/${userLocale}`;

  return {
    getLocalizedArticle: (articleSlug: string | number) => {
      return `${baseUrl}/articles/${articleSlug}`;
    },
    getLocalizedCategory: (categorySlug: string | number) => {
      return `${baseUrl}/categories/${categorySlug}`;
    },
    getLocalizedHelpCenter: baseUrl,
    organizationCountry,
  };
}
